import { SHOW_MODAL, HIDE_MODAL } from './ActionTypes';
export const ModalTypes = {
  POST_PUBLISH: 'POST_PUBLISH'
};
export const showModal = modal => ({
  type: SHOW_MODAL,
  payload: {
    modal
  }
});
export const hideModal = () => ({
  type: HIDE_MODAL
});